import React from 'react';
import styled from 'styled-components';
import { Flex, Heading, Text, Button, Image } from 'rebass';
import JobPostDetails from 'modules/JobPosts/components/JobPostDetails';
import useJobPost from 'modules/JobPosts/hooks/useJobPost';
import Frame from 'components/Frame';
import Link from 'components/Link';
import rejectIcon from 'assets/icons/reject.png';
import editIcon from 'assets/icons/edit.png';
import plusIcon from 'assets/icons/plus.png';
import colors from 'theme/colors';
import { NONPUBLISHED } from 'constants/index';

const HeadingWrapper = styled(Flex)`
  border-bottom: 2px solid ${colors.darkGray};
`;

const HeadingButton = styled(Button)<any>`
  cursor: ${props => (props.loadingProp ? 'wait' : 'pointer')};
  outline: none;
  user-select: none;
`;

const JobPostPreview: React.FC<any> = ({ match }): JSX.Element => {
  const { loading, jobPost, userInfo, deleteJobPostHandler, publishJobPostHandler } = useJobPost(
    +match.params.id
  );
  return (
    <>
      {jobPost && jobPost.status === NONPUBLISHED && (
        <Frame>
          <Flex width="100%" flexDirection="column">
            <Flex flexDirection="column" alignItems="flex-start" py={6}>
              <HeadingWrapper
                width="100%"
                justifyContent="space-between"
                alignItems="center"
                pb={4}
                mb={5}
              >
                <Heading fontSize={['24px']} fontWeight={6} color="primary2">
                  This is a preview of the job posting only.
                </Heading>
                <Flex width="100%" justifyContent="space-between" css="max-width: 400px;">
                  <HeadingButton
                    fontSize="24px"
                    fontWeight={6}
                    color="lightGreen"
                    bg="transparent"
                    px={0}
                    py={0}
                    loadingProp={loading && loading}
                    onClick={deleteJobPostHandler}
                  >
                    <Flex alignItems="center">
                      <Image src={rejectIcon} mr={1} />
                      <Text fontSize="24px" fontWeight={6} color="lightGreen">
                        Delete
                      </Text>
                    </Flex>
                  </HeadingButton>
                  <Link to={`/job-post/edit/${+match.params.id}`} color={colors.lightGreen}>
                    <Flex alignItems="center">
                      <Image src={editIcon} mr={1} />
                      <Text fontSize="24px" fontWeight={6} color="lightGreen">
                        Edit
                      </Text>
                    </Flex>
                  </Link>
                  <HeadingButton
                    fontSize="24px"
                    fontWeight={6}
                    color="lightGreen"
                    bg="transparent"
                    px={0}
                    py={0}
                    loadingProp={loading && loading}
                    onClick={publishJobPostHandler}
                  >
                    <Flex alignItems="center">
                      <Image src={plusIcon} mr={1} />
                      Publish
                    </Flex>
                  </HeadingButton>
                </Flex>
              </HeadingWrapper>
              <JobPostDetails jobPost={jobPost} companyName={userInfo.companyName} />
            </Flex>
          </Flex>
        </Frame>
      )}
    </>
  );
};

export default JobPostPreview;
